export { useBodyResize } from './useBodyResize';
export { useBoolean } from './useBoolean';
export { useClickOutside } from './useClickOutside';
export { useDebounce } from './useDebounce';
export { useDocClick } from './useDocClick';
export { useElementIntoView } from './useElementIntoView';
export { useFetch, type IResult } from './useFetch';
export { useIsMounted } from './useIsMounted';
export { useListenScroll } from './useListenScroll';
export { useOrientation } from './useOrientation';
export { usePrev } from './usePrev';
export { useRaf } from './useRaf';
export { useScrollBottom } from './useScrollBottom';
export { useScrollEnd } from './useScrollEnd';
export { useScrollTop } from './useScrollTop';
export { useThrottle } from './useThrottle';
export { useTitle } from './useTitle';
export { useToggle } from './useToggle';
export { useBeforeunload } from './useBeforeunload';
export { useLoadedScript } from './useLoadedScript';
export { useContentHeight } from './useContentHeight';
export { useEventListener } from './useEventListener';
export { useMethodWhileMounted } from './useMethodWhileMounted';

export { useMethods } from './useMethods';
export { useSetDocColor } from './useSetDocColor';
export { useKeyStroke } from './useKeyStroke';
export { usePageshow } from './usePageshow';
export { useClickContainTarget } from './useClickContainTarget';
